// extracted by mini-css-extract-plugin
export var actions = "_rk-4";
export var item = "_rk-1";
export var price = "_rk-3";
export var quantity = "_rk-2";
export var table = "_rk-0";